// extracted by mini-css-extract-plugin
module.exports =  {"seller-level-tooltip":"mixsyVj","sellerLevelTooltip":"mixsyVj","seller-level":"jEdxuLk","sellerLevel":"jEdxuLk","top-rated":"lAt6BpM","topRated":"lAt6BpM"};